module.exports = __webpack_public_path__ + "img/pg_tele_softbank.26fbb3cf.png";